/**
 * Layout.jsx — Page shell that composes Navbar, page content, and optional Footer.
 *
 * Every route in App.js wraps its page component in <Layout>. The footer is shown
 * on public/marketing pages and hidden on app pages (showFooter={false}) to
 * maximise the working area for data-heavy views like the dashboard.
 *
 * Exports: Layout
 */
import { Navbar } from './Navbar';
import { Footer } from './Footer';

/**
 * Layout — Full-page wrapper with sticky Navbar and optional Footer.
 *
 * @param {React.ReactNode} props.children         - The page content to render in <main>.
 * @param {boolean}         [props.showFooter=true] - Set to false to hide the Footer.
 *                                                    Used on app pages where footer
 *                                                    space is not needed.
 */
export function Layout({ children, showFooter = true }) {
    return (
        <div className="min-h-screen flex flex-col">
            {/* Sticky top navigation bar. Always visible. */}
            <Navbar />
            {/* flex-1 lets the main area grow to fill remaining viewport height. */}
            <main className="flex-1">
                {children}
            </main>
            {/* Footer is rendered only on pages that opt in (e.g. Landing). */}
            {showFooter && <Footer />}
        </div>
    );
}
